module.exports = __webpack_public_path__ + "images/emoji/arrow_down.62f64fa7c51c0ad7c99c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrow_down.png
// module id = kR8m
// module chunks = 2